import {
  AUTH_ENDIMPERSONATING_SUCCESS,
  AUTH_IMPERSONATE_SUCCESS,
  AUTH_SIGNING_OUT_SUCCESS,
  AUTH_SUCCESS,
} from "../actions/auth";
import MonitorActions from "../actions/monitors";
import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("MONITORS");
const CRUD_ACTION_HANDLERS = getActionHandler("MONITORS");
const resetMonitoringState = () => getInitialState("MONITORS");

const customHandlers = {
  [AUTH_IMPERSONATE_SUCCESS]: resetMonitoringState,
  [AUTH_ENDIMPERSONATING_SUCCESS]: resetMonitoringState,
  [AUTH_SIGNING_OUT_SUCCESS]: resetMonitoringState,
  [AUTH_SUCCESS]: resetMonitoringState,
  [MonitorActions.UPDATE_MONITOR_REBALANCING_GROUP_PENDING]: (state, _action) => {
    return { ...state, readyState: MonitorActions.UPDATE_MONITOR_REBALANCING_GROUP_PENDING };
  },
  [MonitorActions.UPDATE_MONITOR_REBALANCING_GROUP_FULFILLED]: (state, action) => {
    const results = action.payload.map((result) => {
      if (result.status === "fulfilled") {
        return {
          status: "fulfilled",
          response: result.value,
        };
      } else {
        return {
          status: "rejected",
          url: result.reason?.config?.url || result.reason?.url || "unknown",
          error: result.reason,
        };
      }
    });
    return { ...state, readyState: MonitorActions.UPDATE_MONITOR_REBALANCING_GROUP_FULFILLED, object: results };
  },
};

export default function monitors(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type] || customHandlers[action.type];
  return handler ? handler(state, action) : state;
}
